/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiAttributeMapping,
    ApiAttributeMappingFromJSON,
    ApiAttributeMappingToJSON,
    ApiMappings,
    ApiMappingsFromJSON,
    ApiMappingsToJSON,
} from '../models';

export interface UpdateAttributeMappingRequest {
    apiAttributeMapping: ApiAttributeMapping;
}

/**
 * 
 */
export class MappingApi extends runtime.BaseAPI {

    /**
     * Fetches attribute mappings for organisation
     */
    async findAttributeMappingsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiMappings>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/mappings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiMappingsFromJSON(jsonValue));
    }

    /**
     * Fetches attribute mappings for organisation
     */
    async findAttributeMappings(initOverrides?: RequestInit): Promise<ApiMappings> {
        const response = await this.findAttributeMappingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates attribute mapping
     */
    async updateAttributeMappingRaw(requestParameters: UpdateAttributeMappingRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiAttributeMapping>> {
        if (requestParameters.apiAttributeMapping === null || requestParameters.apiAttributeMapping === undefined) {
            throw new runtime.RequiredError('apiAttributeMapping','Required parameter requestParameters.apiAttributeMapping was null or undefined when calling updateAttributeMapping.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/mappings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApiAttributeMappingToJSON(requestParameters.apiAttributeMapping),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiAttributeMappingFromJSON(jsonValue));
    }

    /**
     * Updates attribute mapping
     */
    async updateAttributeMapping(requestParameters: UpdateAttributeMappingRequest, initOverrides?: RequestInit): Promise<ApiAttributeMapping> {
        const response = await this.updateAttributeMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
